import { IconButton, InputAdornment } from '@material-ui/core'
import { CancelOutlined } from '@material-ui/icons'

import InputText from '@/components/input-text'

import { SearchTypesComponentsProps } from '..'

export function TextSearchField({
  value,
  onChange,
}: SearchTypesComponentsProps) {
  return (
    <InputText
      aria-label='Campo de busca por texto'
      value={value}
      onChange={(e) => onChange(e.target.value)}
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <IconButton
              color='inherit'
              onClick={() => onChange('')}
              aria-label='Limpar'
            >
              <CancelOutlined />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  )
}
